import React from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import AllContractors from "./AllContractors";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import { useLocation } from "react-router-dom";

const Contractors = () => {
  const location = useLocation();
  usePageActivity(location.pathname, "Contractors");

  document.title = "Contractors | CIMS";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Contractors"
            pageTitles={[{ title: "Dashboard", link: "/dashboard" }]}
          />
          <AllContractors />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Contractors;
